.core-entity-content {
    min-height: 100%;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    /* If changing, update the min width of the lead page (core-entity-page-container.module.css)
    and header (header.module.css) */
    gap: 8px;
    position: relative;
    background-color: white;
    /* Should match the left padding of action bar */
    padding-right: 16px;
    border-radius: 8px;
    margin-bottom: 8px;
}

.core-entity-content--full-height-sidebar {
    min-height: initial;
    border-radius: 0;
}
